import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface LendAndReturnConditionLendClassification {
  id: number
  branchCode: SystemCode
  lendType: SystemCode
  userType: SystemCode
  numberOfBooks: number
  classifications: SystemCode[]
  revision: number
}

export function LendAndReturnConditionLendClassificationFromJSON(
  json: any
): LendAndReturnConditionLendClassification {
  return {
    id: exists(json, 'id') ? json.id : 0,
    branchCode: exists(json, 'branch_code')
      ? SystemCodeFromJSON(json.branch_code)
      : defaultSystemCode(),
    lendType: exists(json, 'lend_type')
      ? SystemCodeFromJSON(json.lend_type)
      : defaultSystemCode(),
    userType: exists(json, 'user_type')
      ? SystemCodeFromJSON(json.user_type)
      : defaultSystemCode(),
    numberOfBooks: exists(json, 'number_of_books') ? json.number_of_books : 0,
    classifications: exists(json, 'classifications')
      ? json.classifications.map(SystemCodeFromJSON)
      : [],
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
